import React from "react";
import { useState, useEffect } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Form, Formik } from "formik";
import Loader from "../components/Helpper/Loader";
import * as Yup from "yup";
import { useTheme } from "@mui/material/styles";
import {
  MyTextInput,
  MyTextArea,
} from "../services/authentication/inputServices";
import { Store } from "react-notifications-component";
import {
  getAllQuery,
  delete_query,
  getEmailHelpCenter,
  updateEmailHelpCenter,
} from "../services/web/webServices";

function HelpAndSupport() {
  const theme = useTheme();
  const [openSidebarToggle, setOpenSidebarToggle] = useState(false);
  const [getLoader, setLoader] = useState(true);
  const [select, setSelection] = useState([]);
  const [getButton, setButton] = useState(true);
  const [showEye, setShowEye] = useState(false);
  const [queryData, setQueryData] = useState([]);
  const [queryDetail, setQueryDetail] = useState([]);
  const [show, setShow] = useState(false);
  const [getEmail, setEmail] = useState([]);
  const OpenSidebar = () => {
    setOpenSidebarToggle(!openSidebarToggle);
  };
  const pageName = "Help And Support";

  const handleClose1 = () => setShowEye(false);
  const handleShow1 = (params) => {
    setQueryData(params);
    setShowEye(true);
  };

  const handleClose = () => setShow(false);

  const handleShow = (params) => {
    setShow(true);
  };
  useEffect(() => {
    setLoader(true);
    getAllQuery()
      .then((res) => {
        const queries = Array.isArray(res?.data?.data) ? res.data.data : [];
        setQueryDetail(
          queries.map((el, index) => ({
            ...el,
            id: el.id,
            i: index,
          }))
        );

        setLoader(false);
      })

      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  }, []);

  useEffect(() => {
    getEmailHelpCenter()
      .then((res) => {
        const data = res?.data?.data;
        setEmail(Array.isArray(data) ? data : data != null ? [data] : []);
      })

      .catch((err) => {
        console.log(err);
      });
  }, []);

  const onDelete = (params) => () => {
    if (window.confirm("Are you sure you want to delete this Query?")) {
      delete_query(params.row.id)
        .then((res) => {
          Store.addNotification({
            title: "Success",
            message: res?.data?.message,
            type: "success",
            insert: "top",
            container: "top-right",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
              duration: 3000,
              onScreen: true,
            },
          });

          setLoader(true);
          getAllQuery()
            .then((res) => {
              const queries = Array.isArray(res?.data?.data) ? res.data.data : [];
              setQueryDetail(
                queries.map((el, index) => ({
                  ...el,
                  id: el.id,
                  i: index,
                }))
              );
              setLoader(false);
            })

            .catch((err) => {
              setLoader(false);
              console.log(err);
            });
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };
  const columns = [
    {
      field: "sno",
      headerName: "S.NO.",
      filterable: false,
      renderCell: (index) => `${index.row.i + 1}`,
      width: 100,
    },

    {
      field: "email",
      headerName: "Email",
      width: 200,
    },

    {
      field: "query",
      headerName: "Query",
      width: 250,
    },

    {
      field: "action",
      headerName: "Action",
      width: 310,

      renderCell: (params) => {
        return (
          <>
            <Button
              style={{
                backgroundColor: "#64A433",
                border: "none",
                marginRight: "5px",
              }}
              onClick={() => handleShow1(params)}
            >
              <i className="fas fa-eye"></i>
            </Button>

            <Button
              color="error"
              onClick={onDelete(params)}
              style={{ backgroundColor: "#64A433", border: "none" }}
            >
              <i className="fa fa-trash" aria-hidden="true"></i>
            </Button>
          </>
        );
      },
    },
  ];
  const css = `
    
  .form-group {
    margin-bottom: 20px;
  }
  
  .form-control {
    width: 100%;
    padding: 8px;
    font-size: 1rem;
    border: 1px solid #ccc;
    border-radius: 4px;
    
  }
    .form-control-edit {
    width: 100%;
    padding: 8px;
    font-size: 1rem;
    border: 1px solid #ccc;
    border-radius: 4px;
    height:110px
  }

    .form-label {
    margin-bottom: 5px;
    display: block;
    font-weight: bold;
  }
        .form-label {
    margin-bottom: 5px;
    display: block;
    font-weight: bold;
    color: #555659; 
  }
     .form-submit{
    padding: 10px 20px;
  background-color: #4CAF50;
  color: white;
  border: none;
  cursor: pointer;  
  border-radius: 5px;
  }
.form-submit:hover {
  background-color: #4CAF50; /* Darker green on hover */
  transform: scale(1.05); /* Slightly enlarge the button */
}

.form-submit:disabled {
  background-color: #9e9e9e; /* Grey color when disabled */
  cursor: not-allowed; /* Change cursor to not-allowed when disabled */
}
   label {
  color: #555659; 
}
    `;
  return (
    <>
      <style>{css}</style>
      <div className="grid-container">
        <Sidebar
          openSidebarToggle={openSidebarToggle}
          OpenSidebar={OpenSidebar}
        />
        <Header OpenSidebar={OpenSidebar} pageName={pageName} />
        <div
          style={{
            gridArea: "main",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            // margin: "0 150px 150px",
            margin: "0 90px 150px",
          }}
        >
          <div
            style={{
              margin: "30px",
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              marginRight: "50px",
            }}
          >
            <Button
              onClick={handleShow}
              style={{
                marginLeft: "750px",
                backgroundColor: "#64A433",
                border: "none",
              }}
            >
              Update Email +
            </Button>
          </div>
          <Box sx={{ height: 500, width: "100%", boxShadow: 7 }}>
            {getLoader ? (
              <Loader />
            ) : queryDetail.length > 0 ? (
              <>
                <DataGrid
                  rows={queryDetail}
                  columns={columns}
                  initialState={{
                    pagination: {
                      paginationModel: { page: 0, pageSize: 10 },
                    },
                  }}
                  pageSizeOptions={[5, 10, 25]}
                  disableRowSelectionOnClick
                  onSelectionChange={(newSelection) => {
                    setSelection(newSelection.rows);
                  }}
                  sx={{
                    "& .MuiDataGrid-row:nth-of-type(odd)": {
                      backgroundColor: theme.palette.action.hover, // Light grey background
                    },
                    "& .MuiDataGrid-cell:last-child": {
                      border: 0, // Hide the last cell border
                    },
                  }}
                />
              </>
            ) : (
              <p style={{ fontSize: "30px", padding: "30px" }}>
                No data found.
              </p>
            )}
          </Box>
          <Modal show={showEye} onHide={handleClose1} size="lg">
            <Modal.Header closeButton>
              <Modal.Title>Query Detail</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Formik
                initialValues={{
                  email: queryData?.row?.email ? queryData?.row?.email : "",
                  query: queryData?.row?.query ? queryData?.row?.query : "",
                }}
              >
                {(props) => (
                  <Form>
                    <div className="form-group">
                      <label className="form-label">Email:</label>
                      <MyTextInput
                        type="text"
                        id="email"
                        name="email"
                        className="form-control"
                        readOnly
                      />
                    </div>

                    <div className="form-group">
                      <label className="form-label">Query:</label>
                      <MyTextArea
                        type="text"
                        id="query"
                        name="query"
                        className="form-control-edit"
                        readOnly
                      />
                    </div>
                  </Form>
                )}
              </Formik>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose1}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
              <Modal.Title>Update Email</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Formik
                initialValues={{
                  email: getEmail?.[0]?.email ?? "",
                }}
                validationSchema={Yup.object({
                  email: Yup.string()
                    .email("Invalid Email Address")
                    .required("Please Enter Email"),
                })}
                onSubmit={(values, { resetForm }) => {
                  setButton(false);

                  updateEmailHelpCenter(getEmail[0]?.id, values)
                    .then((res) => {
                      setButton(true);

                      Store.addNotification({
                        title: "Success",
                        message: "Email Updated Successfully",
                        type: "success",
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animate__animated", "animate__fadeIn"],
                        animationOut: ["animate__animated", "animate__fadeOut"],
                        dismiss: {
                          duration: 5000,
                          onScreen: true,
                        },
                      });
                      resetForm({ values: "" });
                      getEmailHelpCenter()
                        .then((res) => {
                          const data = res?.data?.data;
                          setEmail(Array.isArray(data) ? data : data != null ? [data] : []);
                        })

                        .catch((err) => {
                          console.log(err);
                        });
                      handleClose();
                    })
                    .catch((error) => {
                      setButton(true);
                      if (error) {
                        Store.addNotification({
                          title: "Error!",
                          message: error?.response?.data?.message,
                          type: "danger",
                          insert: "top",
                          container: "top-right",
                          animationIn: ["animate__animated", "animate__fadeIn"],
                          animationOut: [
                            "animate__animated",
                            "animate__fadeOut",
                          ],
                          dismiss: {
                            duration: 5000,
                            onScreen: true,
                          },
                        });
                      }
                    });
                }}
              >
                {(props) => (
                  <Form>
                    <div className="form-group">
                      <label className="form-label">Email:</label>
                      <MyTextInput
                        type="email"
                        id="email"
                        name="email"
                        placeholder="Enter Email"
                        className="form-control"
                      />
                    </div>

                    {getButton === true ? (
                      <Button type="submit" className="form-submit">
                        Update
                      </Button>
                    ) : (
                      <Button type="submit" className="form-submit" disabled>
                        Please Wait!!
                      </Button>
                    )}
                  </Form>
                )}
              </Formik>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    </>
  );
}

export default HelpAndSupport;
